<template>
  <div class="for-chart-container ">
    <div class="button-container">
      <a class="toggle button is-primary" @click="toggleCI">{{!toHideErrorBar ? 'SHOW' : 'HIDE'}} C.I.</a>
    </div>
    <template v-if="chartOptions.option != null">
        <vue-highcharts
          type="chart"
          :options="chartOptions.option "
          :redrawOnUpdate="false"
          :oneToOneUpdate="true"
          :animateOnUpdate="true"
          :customClass="'wideChart'"
          @rendered="onRender"
          @update="onUpdate"
          @destroy="onDestroy"/>
    </template>
  </div>
</template>

<script>
/*
1. each relative abundance with tree ages are rendered with its own x axis, e..g pine (tree age 0, 20, ...)
there will be 4 series for each species group: main column, error bar on main column, CC error bar + spline connecting the error bars
2. series without tree ages are grouped by is series category. e.g. veg type, and human footprint,
one group will rendered in same x axis.
there will be 2 series for each category groups: main column + error bar

the width of each axis will be determined by total number of x axis and each axis has how many columns.

*/
import { reactive, ref, watch } from 'vue';
import { useApp } from '@/composables/state/profileState';
import Vue3Highcharts from '@/components/vue3-highcharts/index';

import { loadData } from './forest-spp-habitat-chart-option.js'
import { useI18n } from 'vue-i18n';

export default {
  name: 'forest-spp-hab-association-section',
  components: {
    'vue-highcharts': Vue3Highcharts
  },
  props: ['isSpecies'],
  setup (props) {
    const { tm } = useI18n();
    const isLoaded = ref(0);
    const { state } = useApp();
    const chartOptions = reactive({}); /* can't modify const itself, use .option to update */
    const hideErrorChartOptions = reactive({});
    const toHideErrorBar = ref(true);
    const chart = ref();

    watch(() => state.tsn, async (newVal, oldVal) => {
      if (newVal && newVal !== oldVal) {
        loadChartData(tm, state, props, chartOptions, isLoaded);
      }
    });
    // const optionData = computed(() => {
    //   return toHideErrorBar.value ? hideErrorChartOptions.option : chartOptions.option;
    // })
    const loadChartData = async () => {
      if (state.tsn) {
        await loadData(tm, state, props, chartOptions, isLoaded);
        const series = chartOptions.option.series?.filter(x => x.type === 'column');
        hideErrorChartOptions.option = { ...chartOptions.option };
        hideErrorChartOptions.option.series = series;
      }
    };
    const toggleCI = () => {
      if (chart.value) {
        chart.value.series.forEach(x => {
          if (x.type === 'errorbar') {
            if (toHideErrorBar.value === true) {
              x.hide();
            } else {
              x.show();
            }
          }
        });
        toHideErrorBar.value = !toHideErrorBar.value;
      }
    };
    const onRender = (inChart) => {
      chart.value = inChart;
    };
    return {
      chartOptions,
      hideErrorChartOptions,
      loadChartData,
      toHideErrorBar,
      isLoaded,
      onRender,
      toggleCI
    }
  },
  created () {
    this.loadChartData();
  }
}
</script>

<style scoped>
.for-chart-container {
  max-width: 100%;
  overflow-y: auto!important;
}
.toggle.button {
  padding: 10px 10px;
  height: 20px;
  min-height: 10px;
}
.button-container {
  text-align: right;
  display: flex;
  justify-content: flex-end;
}
</style>
